import React, { useState, Component } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormSection, TextField, SelectField, TextAreaField, DisplayField } from '../components/FormComponents';
import { mockProducts, masterDataSets } from '../data/mockData';
export function ProductForm() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const mode = id ? 'edit' : 'create';
  const initialData = mode === 'edit' && id ? mockProducts.find(p => p.id === id) : null;
  const [formData, setFormData] = useState<any>(initialData || {
    productCode: 'PROD-AUTO',
    productName: '',
    productType: '',
    category: '',
    subCategory: '',
    unitOfMeasure: '',
    defaultRate: '',
    warranty: '',
    status: 'Active',
    notes: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert(`Product ${mode === 'create' ? 'created' : 'updated'} successfully!`);
    navigate('/products');
  };
  return <div className="space-y-6 max-w-4xl mx-auto" data-id="element-1415">
      <div className="flex items-center justify-between" data-id="element-1416">
        <div data-id="element-1417">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1418">
            {mode === 'create' ? 'Create Product' : 'Edit Product'}
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-1419">
            Configure product details and specifications.
          </p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="bg-white shadow-sm rounded-lg border border-gray-200 p-6 md:p-8" data-id="element-1420">
        <FormSection title="Basic Information" data-id="element-1421">
          {mode === 'edit' ? <DisplayField label="Product Code" value={formData.productCode} data-id="element-1422" /> : <TextField label="Product Code" name="productCode" value={formData.productCode} disabled required data-id="element-1423" />}
          <TextField label="Product Name" name="productName" value={formData.productName} onChange={handleChange} required data-id="element-1424" />

          <SelectField label="Product Category" name="productType" value={formData.productType} onChange={handleChange} required options={[{
          value: 'Raw Material',
          label: 'Raw Material'
        }, {
          value: 'Finished Goods',
          label: 'Finished Goods'
        }, {
          value: 'Consumable',
          label: 'Consumable'
        }, {
          value: 'Service',
          label: 'Service'
        }]} data-id="element-1425" />
          <SelectField label="Product Sub Category" name="category" value={formData.category} onChange={handleChange} required options={[{
          value: 'Stationary',
          label: 'Stationary'
        }, {
          value: 'Food',
          label: 'Food'
        }, {
          value: 'Electronics',
          label: 'Electronics'
        }, {
          value: 'Others',
          label: 'Others'
        }]} data-id="element-1426" />
          <SelectField label="Unit of Measure" name="unitOfMeasure" value={formData.unitOfMeasure} onChange={handleChange} required options={[{
          value: 'pcs',
          label: 'pcs'
        }, {
          value: 'box',
          label: 'box'
        }, {
          value: 'kg',
          label: 'kg'
        }, {
          value: 'lot',
          label: 'lot'
        }]} data-id="element-1427" />
          <TextField label="Default Rate" name="defaultRate" type="number" value={formData.defaultRate} onChange={handleChange} data-id="element-1428" />
          <TextField label="Warranty" name="warranty" value={formData.warranty} onChange={handleChange} data-id="element-1429" />
          <SelectField label="Status" name="status" value={formData.status} onChange={handleChange} required options={[{
          value: 'Active',
          label: 'Active'
        }, {
          value: 'Inactive',
          label: 'Inactive'
        }]} data-id="element-1430" />
        </FormSection>

        <FormSection title="Additional Notes" data-id="element-1431">
          <TextAreaField label="Notes / Comments" name="notes" value={formData.notes} onChange={handleChange} rows={3} data-id="element-1432" />
        </FormSection>

        <div className="mt-8 pt-5 border-t border-gray-200 flex justify-end space-x-3" data-id="element-1433">
          <button type="button" onClick={() => navigate(-1)} className="px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-1434">
            Cancel
          </button>
          <button type="submit" className="px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-1435">
            {mode === 'create' ? 'Save Product' : 'Update Product'}
          </button>
        </div>
      </form>
    </div>;
}